
import md5 from 'blueimp-md5/js/md5.min.js'
import parallel from 'async/parallel'
riot.tag2('coupon-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/coupons"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;products&quot;, &quot;0100&quot;) : checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{isNew ? item.code || \'Добавление купона\' : item.code || \'Редактирование купона\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#coupon-edit-home">Параметры купона</a></li>\n      <li if="{item.type == &quot;g&quot;}"><a data-toggle="tab" href="#coupon-edit-products">Товары</a></li>\n      <li if="{item.type == &quot;g&quot;}"><a data-toggle="tab" href="#coupon-edit-categories">Категории товаров</a></li>\n      <li if="{item.type == &quot;g&quot; &amp;&amp; checkPermission(&quot;orders&quot;, &quot;1000&quot;)}"><a data-toggle="tab" href="#coupon-edit-history">История использования</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="coupon-edit-home">\n          <div class="row">\n            <div class="col-md-4">\n              <div class="form-group {has-error: error.code}">\n                <label class="control-label">Код</label>\n                <div class="input-group">\n                  <input class="form-control" name="code" value="{item.code}" __readonly="{!isNew}">\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" onclick="{generateCode}"><i class="fa fa-random text-primary"></i></div>\n                  </div>\n                </div>\n                <div class="help-block">{error.code}</div>\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group {has-error: error.type}">\n                <label class="control-label">Тип скидки</label>\n                <select class="form-control" name="type" value="{item.type}">\n                  <option value="p">Процент на скидку</option>\n                  <option value="a">Абсолютная скидка на корзину</option>\n                  <option value="g">Процент на позиции товаров</option>\n                </select>\n                <div class="help-block">{error.type}</div>\n              </div>\n            </div>\n            <div class="col-md-4">\n              <div class="form-group">\n                <label class="control-label">До даты</label>\n                <datetime-picker class="form-control" name="expireDate" value="{item.expireDate}" format="YYYY-MM-DD"></datetime-picker>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Значение</label>\n                <div class="{&quot;input-group&quot;: item.type != &quot;a&quot;}">\n                  <input class="form-control" name="discount" value="{item.discount}" type="{\'number\'}"><span class="input-group-addon" if="{item.type != &quot;a&quot;}">%</span>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Кол-во</label>\n                <input class="form-control" name="countUsed" value="{item.countUsed}" step="1" min="0" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3">\n              <div class="form-group">\n                <label class="control-label">Мин. сумма заказа</label>\n                <input class="form-control" name="minSumOrder" value="{item.minSumOrder}" step="0.01" min="0" type="{\'number\'}">\n              </div>\n            </div>\n            <div class="col-md-3" if="{item.type == &quot;a&quot;}">\n              <div class="form-group">\n                <label class="control-label">Валюта</label>\n                <select class="form-control" name="currency" value="{item.curr}">\n                  <option each="{c, i in currencies}" value="{c.name}" __selected="{c.name == item.curr}" no-reorder>{c.title}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <div class="form-group">\n                <label class="control-label">Пользователь</label>\n                <div class="input-group">\n                  <div class="input-group-btn" if="{item.idUser}"><a class="btn btn-default" href="#persons/{item.idUser}" target="_blank"><i class="fa fa-eye"></i></a></div>\n                  <input class="form-control" value="{item.idUser ? item.idUser + &quot; - &quot;  + item.userName : &quot;&quot;}" readonly>\n                  <div class="input-group-btn">\n                    <div class="btn btn-default" if="{checkPermission(&quot;contacts&quot;, &quot;1000&quot;)}" onclick="{changeUser}"><i class="fa fa-list text-primary"></i></div>\n                    <div class="btn btn-default" onclick="{removeUser}"><i class="fa fa-remove text-danger"></i></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="onlyRegistered" type="checkbox" __checked="{item.onlyRegistered == &quot;Y&quot;}" data-bool="Y,N">Для авторизованных\n                  </label>\n                </div>\n                <div class="checkbox-inline">\n                  <label>\n                    <input name="status" type="checkbox" __checked="{item.status == &quot;Y&quot;}" data-bool="Y,N">Активен\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="coupon-edit-products" if="{item.type == &quot;g&quot;}">\n          <catalog-static name="products" rows="{item.products}" cols="{productsCols}" add="{addProducts}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="code">{row.code}</datatable-cell>\n              <datatable-cell name="article">{row.article}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n              <datatable-cell name="price">{row.price}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="coupon-edit-categories" if="{item.type == &quot;g&quot;}">\n          <catalog-static name="groups" rows="{item.groups}" cols="{groupsCols}" add="{addGroups}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="name">{row.name}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n        <div class="tab-pane fade" id="coupon-edit-history" if="{checkPermission(&quot;orders&quot;, &quot;1000&quot;)}">\n          <catalog-static remove-toolbar="true" rows="{item.orders}" cols="{ordersCols}">\n            <yield to="body">\n              <datatable-cell name="id">{row.id}</datatable-cell>\n              <datatable-cell name="dateOrder">{row.dateOrder}</datatable-cell>\n              <datatable-cell name="customer">{row.customer}</datatable-cell>\n              <datatable-cell name="amount">{row.amount}</datatable-cell>\n              <datatable-cell name="couponDiscount">{row.couponDiscount}</datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');
self.item = {};

self.rules = {
    code: 'empty',
    type: 'empty'
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.productsCols = [{ name: 'id', value: '#' }, { name: 'code', value: 'Код' }, { name: 'article', value: 'Артикул' }, { name: 'name', value: 'Наименование' }, { name: 'price', value: 'Цена' }];

self.groupsCols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }];

self.ordersCols = [{ name: 'id', value: '#' }, { name: 'dateOrder', value: 'Дата заказа' }, { name: 'customer', value: 'Заказчик' }, { name: 'amount', value: 'Сумма заказа' }, { name: 'couponDiscount', value: 'Скидка' }];

self.addProducts = function () {
    modals.create('products-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            self.item.products = self.item.products || [];

            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            var ids = self.item.products.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) {
                    self.item.products.push(item);
                }
            });

            self.update();
            this.modalHide();
        }
    });
};

self.addGroups = function () {
    modals.create('group-select-modal', {
        type: 'modal-primary',
        submit: function submit() {
            self.item.groups = self.item.groups || [];

            var items = this.tags['catalog-tree'].tags.treeview.getSelectedNodes();
            var ids = self.item.groups.map(function (item) {
                return item.id;
            });

            items.forEach(function (item) {
                if (ids.indexOf(item.id) === -1) self.item.groups.push(item);
            });

            self.update();
            this.modalHide();
        }
    });
};

self.submit = function () {
    self.error = self.validation.validate(self.item, self.rules);

    if (!self.error) {
        API.request({
            object: 'Coupon',
            method: 'Save',
            data: self.item,
            success: function success(response) {
                self.item = response;
                popups.create({ title: 'Успех!', text: 'Купон сохранен!', style: 'popup-success' });
                if (self.isNew) riot.route('products/coupons/' + self.item.id);
                self.update();
            }
        });
    }
};

self.reload = function () {
    return observable.trigger('coupons-edit', self.item.id);
};

self.generateCode = function () {
    if (self.isNew) self.item.code = md5(Math.random().toString(36).substring(7));
    self.error = self.validation.validate(self.item, self.rules, 'code');
};

self.changeUser = function () {
    modals.create('persons-list-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();
            self.item.idUser = items[0].id;
            self.item.userName = items[0].displayName;
            self.update();
            this.modalHide();
        }
    });
};

self.removeUser = function () {
    self.item.idUser = null;
    self.item.userName = null;
};

observable.on('coupons-new', function () {
    self.error = false;
    self.item = {};
    self.isNew = true;
    self.update();

    API.request({
        object: 'Currency',
        method: 'Fetch',
        data: {},
        success: function success(response) {
            self.currencies = response.items;
        },
        complete: function complete() {
            self.update();
        }
    });
});

observable.on('coupons-edit', function (id) {
    self.error = false;
    self.loader = true;
    self.item = {};
    self.isNew = false;
    self.update();

    parallel([function (callback) {
        API.request({
            object: 'Coupon',
            method: 'Info',
            data: { id: id },
            success: function success(response) {
                self.item = response;
                callback(null, 'Coupon');
            },
            error: function error() {
                callback('error', null);
            }
        });
    }, function (callback) {
        API.request({
            object: 'Currency',
            method: 'Fetch',
            data: {},
            success: function success(response) {
                self.currencies = response.items;
                callback(null, 'Currencies');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }], function () {
        self.loader = false;
        self.update();
    });
});
});


// WEBPACK FOOTER //
// ./pages/products/coupons/coupon-edit.tag